export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/car/index/resources/computed.js